export default "__VITE_ASSET__BbzIQNII__"